import { Component, OnInit, TemplateRef} from '@angular/core';
import { ContentService } from '../../shared/content.service';

import { BsModalService, BsModalRef } from 'ngx-bootstrap';

@Component({
  selector: 'app-discover demo-modal-sizes',
  templateUrl: './discover.component.html',
  styleUrls: ['./discover.component.scss'],
})
export class DiscoverComponent implements OnInit {

  page: Object;
  
  constructor(private contentService: ContentService, private modalService: BsModalService) { 
  }

  ngOnInit() {
    this.page = this.contentService.pages['discover'];
  }

  modalRef: BsModalRef;
 
  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, {
      animated: true,
      backdrop: 'static',
      class: 'modal-fluid'
    });
  }

}
